import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  creditMemoApplyTable,
  creditMemoitemsTable,
  purchaseOrderItemsExpensesTable,
  purchaseOrderItemsTable,
} from "../../../config/grid-column-defs";
import {
  getTransactionCreditMemoItem,
  getTransactionpurchaseorderitemdetails,
  getTransactionVendorCreditApply,
} from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Tabs,
  Tab,
  Grid,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../../components/TabPanel";

export default function PurchaseOrderItems() {
  const [tabIndex, setTabIndex] = useState(0);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];

  const [discount, setDiscountData] = useState("");
  const [taxOverride, setTaxOverrideData] = useState("");
  const [taxDateOverride, setTaxDateOverrideData] = useState("");
  const [avataxOverrideDate, setAvataxOverrideDateData] = useState("");
  const [rate, setRateData] = useState("");
  const [unapplied, setUnappliedData] = useState("");
  const [applied, setAppliedData] = useState("");
  const [taxCredit, setTaxCreditData] = useState("");

  const [itemsSum, setItemsSum] = useState("");
  const [applySum, setApplySum] = useState("");

  // useEffect(() => {
  //   if (user.token) {
  //     getTransactionCreditMemoItemData();
  //   }
  // }, [user.token]);

  async function getTransactionPurchaseOrderItemData(limit=10, offset=0) {
    setLoading(true);
    try {
      const { data } = await getTransactionpurchaseorderitemdetails(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setItemsSum(data.data.itemsum);
      setDiscountData(data.data.discount);
      setTaxOverrideData(data.data.tax_override);
      setTaxDateOverrideData(data.data.tax_date_override);
      setAvataxOverrideDateData(data.data.avatax_override_date);
      setRateData(data.data.rate);
      setUnappliedData(data.data.unapplied);
      setAppliedData(data.data.applied);
      setTaxCreditData(data.data.tax_credit);
      setLoading(false);
      return {
        rows: data.data.items,
        total: data.data.itemtotal,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      //snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
       <Box sx={{ p: 1 }}>
       <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
                <Tab label="Items 0.00" />
               
              </Tabs>
              {/*------------Sub Tab Items------------*/}
              <TabPanel value={tabIndex} index={0}>
                <AgGridPaginatedTable
                  getTableRows={getTransactionPurchaseOrderItemData}
                  columns={purchaseOrderItemsTable}
                  perPage={5}
                  refreshCounter={0}
                />
              </TabPanel>
             
            </Box>
    </>
  );
}
